import React from 'react';
import { withRouter } from "react-router-dom";
class ScrollToTop extends React.Component {
    componentDidUpdate() {
        document.querySelector("main").scrollIntoView(true)
    }
    render() {
        return this.props.children;
    }
}
const PageContainer = withRouter(ScrollToTop);
export default PageContainer